import { type FC } from 'react'
import { PREP_QUESTIONS_SUBTITLE, PREP_QUESTIONS_TITLE } from './prepQuestionsConfig'
import { MeetingInsightsCard } from '../MeetingInsights/MeetingInsightsCard'

const SKELETON_ROW_COUNT = 4

export const PrepQuestionsSkeleton: FC = () => {
  return (
    <MeetingInsightsCard title={PREP_QUESTIONS_TITLE} subtitle={PREP_QUESTIONS_SUBTITLE} subtitlePlacement='below'>
      {Array.from({ length: SKELETON_ROW_COUNT }).map((_, i) => (
        <p key={i} className='m-0 py-1 w-100 paragraph-medium skeleton zocks-border-0.25'>
          &nbsp;
        </p>
      ))}
    </MeetingInsightsCard>
  )
}
